import { createSelector } from 'reselect'
import { getTierOrder } from 'loyalty/lib/tierUtils'

/**
 * Selector to get tier thresholds from the loyalty config.
 * Returns undefined until the config API has loaded.
 */
const getLoyaltyTierThresholds = createSelector(
  (state: App.State) => state.loyalty.config,
  (config): Record<App.LoyaltyTier, App.LoyaltyTierThreshold> | undefined => {
    return config?.tierThresholds
  },
)

export function getTierThreshold(
  thresholds: Record<App.LoyaltyTier, App.LoyaltyTierThreshold>,
  tier: App.LoyaltyTier,
): App.LoyaltyTierThreshold {
  return thresholds[tier]
}

export function getTiersAbove(currentTier: App.LoyaltyTier): Array<App.LoyaltyTier> {
  const tiersOrder = getTierOrder()
  const currentIndex = tiersOrder.indexOf(currentTier)

  if (currentIndex === -1 || currentIndex === tiersOrder.length - 1) {
    return []
  }

  return tiersOrder.slice(currentIndex + 1)
}

export default getLoyaltyTierThresholds
